import React, {useState} from "react";
import {Box, Button, Columns, Form, Icon} from "react-bulma-components";
import Collapsible from "react-collapsible";
import {faPoundSign} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import axios from "axios";
import {asyncContainer, Typeahead} from "react-bootstrap-typeahead";

const AsyncTypeahead = asyncContainer(Typeahead);

export default function NewMovementRate({onSave}){
    const [isLoading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [, setTypeahead] = useState();


    const [rate, setRate] = useState({
        name: "",
        cost_per_mile: 0,
        vehicle_cost: 0,
        additional_time_cost: 0,
        callout_cost: 0,
        supplier_cost_per_mile: 0,
        supplier_one_off_charge: 0,
        external_cost_per_mile: 0,
        external_one_off_charge: 0,
        hide: false,
        comments: "",
        customer: null
    });


    const onChange = e => {
        let newRate = {...rate, [e.target.name]: e.target.value}
        setRate(newRate);
    };

    const handleContactSelect = e => {
        const toUpdate = {
            target: {
                name: "customer",
                value: e[0]
            }
        };
        onChange(toUpdate);
    }

    const handleSearch = e => {
        setLoading(true);
        axios.get(`/api/contacts?contact_type=CC&search=${e}`).then(resp => {
          setSearchData(resp.data.results);
          setLoading(false);
        });
    };



    return (
        <Box>
            <Collapsible
                className={"title"}
                trigger={"Add Movement Rate"}
                triggerOpenedClassName={"title"}
            >
                <Columns>
                    <Columns.Column>
                        <Form.Field>
                            <Form.Label>Name</Form.Label>
                            <Form.Input
                                name={"name"}
                                type={"text"}
                                onChange={onChange}
                                value={rate.name}
                            />
                        </Form.Field>
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Field>
                            <Form.Label>Cost Per Mile</Form.Label>
                            <Form.Control className={"has-addons"}>
                                <Form.Input
                                    type={"number"}
                                    name={"cost_per_mile"}
                                    value={rate.cost_per_mile}
                                    onChange={onChange}
                                />
                                <Icon align={"left"} className={"small-icon"}>
                                  <FontAwesomeIcon icon={faPoundSign}/>
                                </Icon>
                            </Form.Control>
                        </Form.Field>
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Field>
                            <Form.Label>Vehicle Cost</Form.Label>
                            <Form.Control className={"has-addons"}>
                                <Form.Input
                                    type={"number"}
                                    name={"vehicle_cost"}
                                    value={rate.vehicle_cost}
                                    onChange={onChange}
                                />
                                <Icon align={"left"} className={"small-icon"}>
                                  <FontAwesomeIcon icon={faPoundSign}/>
                                </Icon>
                            </Form.Control>
                        </Form.Field>
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Field>
                            <Form.Label>Additional Time Cost</Form.Label>
                            <Form.Control className={"has-addons"}>
                                <Form.Input
                                    type={"number"}
                                    name={"additional_time_cost"}
                                    value={rate.additional_time_cost}
                                    onChange={onChange}
                                />
                                <Icon align={"left"} className={"small-icon"}>
                                  <FontAwesomeIcon icon={faPoundSign}/>
                                </Icon>
                            </Form.Control>
                        </Form.Field>
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Field>
                            <Form.Label>Callout Cost</Form.Label>
                            <Form.Control className={"has-addons"}>
                                <Form.Input
                                    type={"number"}
                                    name={"callout_cost"}
                                    value={rate.callout_cost}
                                    onChange={onChange}
                                />
                                <Icon align={"left"} className={"small-icon"}>
                                  <FontAwesomeIcon icon={faPoundSign}/>
                                </Icon>
                            </Form.Control>
                        </Form.Field>
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Field>
                            <Form.Label>Internal Cost Per Mile</Form.Label>
                            <Form.Control className={"has-addons"}>
                                <Form.Input
                                    type={"number"}
                                    name={"supplier_cost_per_mile"}
                                    value={rate.supplier_cost_per_mile}
                                    onChange={onChange}
                                />
                                <Icon align={"left"} className={"small-icon"}>
                                  <FontAwesomeIcon icon={faPoundSign}/>
                                </Icon>
                            </Form.Control>
                        </Form.Field>
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Field>
                            <Form.Label>One Off Internal Cost</Form.Label>
                            <Form.Control className={"has-addons"}>
                                <Form.Input
                                    type={"number"}
                                    name={"supplier_one_off_charge"}
                                    value={rate.supplier_one_off_charge}
                                    onChange={onChange}
                                />
                                <Icon align={"left"} className={"small-icon"}>
                                  <FontAwesomeIcon icon={faPoundSign}/>
                                </Icon>
                            </Form.Control>
                        </Form.Field>
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Field>
                            <Form.Label>External Supplier Cost Per Mile</Form.Label>
                            <Form.Control className={"has-addons"}>
                                <Form.Input
                                    type={"number"}
                                    name={"external_cost_per_mile"}
                                    value={rate.external_cost_per_mile}
                                    onChange={onChange}
                                />
                                <Icon align={"left"} className={"small-icon"}>
                                  <FontAwesomeIcon icon={faPoundSign}/>
                                </Icon>
                            </Form.Control>
                        </Form.Field>
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Field>
                            <Form.Label>One Off External Cost</Form.Label>
                            <Form.Control className={"has-addons"}>
                                <Form.Input
                                    type={"number"}
                                    name={"external_one_off_charge"}
                                    value={rate.external_one_off_charge}
                                    onChange={onChange}
                                />
                                <Icon align={"left"} className={"small-icon"}>
                                  <FontAwesomeIcon icon={faPoundSign}/>
                                </Icon>
                            </Form.Control>
                        </Form.Field>
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Label>Customer</Form.Label>
                        <AsyncTypeahead
                          useCache={false}
                          id="typeahead"
                          labelKey="display_name"
                          minLength={2}
                          name={"contact"}
                          onSearch={handleSearch}
                          onChange={handleContactSelect}
                          placeholder={"Search Customer"}
                          options={searchData}
                          ref={typeahead => setTypeahead(typeahead)}
                          className="typeahead"
                          isLoading={isLoading}
                          selected={
                            rate.customer && rate.customer.id ? [rate.customer] : []
                          }
                        />
                    </Columns.Column>
                    <Columns.Column>
                        <Form.Label>Comments</Form.Label>
                        <Form.Textarea
                            value={rate.comments}
                            name={"comments"}
                            onChange={onChange}
                        />
                    </Columns.Column>
                </Columns>
                <Columns>
                    <Columns.Column>
                        <Button
                            color={"success"}
                            onClick={() => onSave(rate)}
                            fullwidth
                        >
                            Create
                        </Button>
                    </Columns.Column>
                </Columns>
            </Collapsible>
        </Box>
    )


}